<template>
    <div style="width:100%;height:100%;overflow-x:hidden;">
        <login-box :show="xShowingLogin" @oncancel="showLogin(false)" @onlogin="onLoginCallback"></login-box>
        <Loading :show="isLoading"></Loading>

        <filter-menu :filter-info="filterInfo" v-if="showMenu" @onclose="showMenu = false" :listing-type="listingType"
            :shop-code="shopInfo.shopCode"></filter-menu>

        <layout @onLayoutChange="onLayoutChange">
            <template v-slot:topNavBrand>
                    <span class="navbar-brand" :title="shopInfo.shopName"><router-link to="/"><span class="agx-shop-name"
                            style="outline: none;border-color: #9ecaed;">{{ shopInfo.shopName}}</span>
                        </router-link>
                    </span>
            </template>
            <template v-slot:topNavRight>
                <span v-if="configs.showSearch" class="navbar-brand" style="float:right;">
                    <span class="act-menu-btn glyphicon glyphicon-search" @click="toggleMenu"></span>
                </span>
            </template>
            <template v-slot:topNavMenus>
                <ul class="nav navbar-nav">
                    <li><router-link :to="{ name: listingType }"><span class="glyphicon glyphicon-list"></span>
                            {{ lang.navi.listing }} </router-link></li>
                    <template v-if="shopInfo.isCartAllowed">
                        <li v-if="hasLogin"><router-link to="/cart"><span class="glyphicon glyphicon-shopping-cart"></span>
                                {{ lang.navi.cart }} </router-link></li>
                        <li v-if="!hasLogin"><router-link to="/wishList"><span
                                    class="glyphicon glyphicon-heart"></span> {{ lang.navi.wishList }}
                            </router-link>
                        </li>
                        <li v-if="hasLogin"><router-link to="/orders"><span class="glyphicon glyphicon-check"></span>
                                {{ lang.navi.orders }} </router-link></li>
                        <li><router-link to="about"><span class="glyphicon glyphicon-info-sign"></span> {{ lang.navi.about
                        }}
                            </router-link></li>
                        <li v-if="hasLogin"> <router-link to="/account" @click.prevent="showLogin(true)"><span
                                    class="glyphicon glyphicon-user"></span> {{ lang.navi.account }}</router-link></li>
                        <li v-else> <a href="#" @click.prevent="showLogin(true)"><span
                                    class="glyphicon glyphicon-user"></span> {{ lang.navi.login }} </a></li>
                    </template>
                </ul>
            </template>

            <template v-slot:sideMenu>
                <div class="agx-navbar-shop">
                    <router-link v-if="hasLogin" to="/account">
                        <div
                            style="border-top: 1px solid #ccc; display: block;width: 100%; height: 80px; padding: 29px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span style="font-size:2em;" class="glyphicon glyphicon-user"></span> {{ xAccount.displayName }}
                        </div>
                    </router-link>
                    <router-link to="/">
                        <div
                            style="display: block;width: 100%; height: 80px; padding: 29px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span class="glyphicon glyphicon-home"></span> {{ shopInfo.shopName }}
                        </div>
                    </router-link>
                </div>
                <div class="agx-navbar-shop">
                    <router-link :to="{ name: listingType }">
                        <div
                            style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc;">
                            <span class="glyphicon glyphicon-list"></span> {{ lang.navi.listing }}
                        </div>
                    </router-link>
                    <template v-if="shopInfo.isCartAllowed">

                        <router-link v-if="hasLogin" to="/cart">
                            <div
                                style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                                <span class="glyphicon glyphicon-shopping-cart"></span> {{ lang.navi.cart }}
                            </div>
                        </router-link>
                        <router-link v-if="!hasLogin" to="/wishList">
                            <div
                                style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                                <span class="glyphicon glyphicon-shopping-cart"></span> {{ lang.navi.wishList }}
                            </div>
                        </router-link>
                        <router-link v-if="hasLogin" to="/orders">
                            <div
                                style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                                <span class="glyphicon glyphicon-check"></span> {{ lang.navi.orders }}
                            </div>
                        </router-link>
                        <router-link to="about">
                            <div
                                style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                                <span class="glyphicon glyphicon-info-sign"></span> {{ lang.navi.about }}
                            </div>
                        </router-link>
                        <!--<router-link v-if="hasLogin" to="/account" @click.prevent="showLogin(true)"><div style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc; "> <span class="glyphicon glyphicon-user"></span>  {{lang.navi.account}}</div></router-link>-->
                        <div v-if="!hasLogin"
                            style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; line-height: 1.42857143; border-bottom: 1px solid #ccc;cursor:pointer;"
                            @click.prevent="showLogin(true)"><span class="glyphicon glyphicon-user"></span>
                            {{ lang.navi.login }}</div>
                    </template>
                </div>

                <div style="text-align:center;height:50px;line-height:50px;font-size:1.5em;">
                    <span v-if="configs.showSearch" class="act-menu-btn glyphicon glyphicon-search"
                        @click="toggleMenu"></span>
                </div>
                <div>
                    <shop-contacts :contacts="shopContacts"></shop-contacts>
                </div>

            </template>
            <template v-slot:topBody>
                <div v-if="showLaws">
                    <laws @onclose="showLaws = false"></laws>
                </div>
                <div :style="{ display: showIndexTop ? 'block' : 'none' }" v-if="showIndexTop">
                    <index-top :filter-info="filterInfo" :slider-data="sliderData" :configs="configs"></index-top>
                </div>
                <div>
                    <!--for spa index page (pagedInfos index)-->
                    <keep-alive>
                        <router-view name="cacheindex"></router-view>
                    </keep-alive>
                </div>
            </template>

            <template v-slot:leftBody>
                <div style="position:relative;height:100%;border-right: 1px solid gray;overflow-y: auto;" :style="{ 'padding-top': '60px' }">
                    <div
                        style="position: absolute; top: 1px; width: 100%; z-index: 1; box-shadow: rgb(236 236 236) 0px 10px 15px;">
                        <filter-menu-form :show-key-only="true" :any-change="showMenu" :filter-info="filterInfo"
                            :listing-type="listingType" :shop-code="shopInfo.shopCode"></filter-menu-form>
                    </div>
                    <div style="position:relative;height:100%;overflow:auto;padding-top:6px;">
                        <listing-raw :filter-info="filterInfo" :listing-type="listingType"
                            @itemsLoaded="onLeftListingLoaded"></listing-raw>
                        <div style="width:100%;height:60px;"></div>
                    </div>
                </div>
            </template>
            <template v-slot:body>
                <div class="container-fluid" style="width:100%;max-height:100%;">
                    <router-view :key="$route.fullPath"></router-view>
                    <template v-if="showPlaceHolder">
                        <div>
                            <!-- <index-top :filter-info="filterInfo" :configs="configs"></index-top> -->
                            <template v-if="leftListingItems && leftListingItems.filter.count ===0">
                                <div class="alert alert-warning">No Match Items</div>
                                <filter-menu-form :any-change="showMenu" :filter-info="filterInfo"
                                    :listing-type="listingType" :shop-code="shopInfo.shopCode"></filter-menu-form>
                            </template>
                            <template v-else>
                                <div v-if="leftListingItems && leftListingItems.filter.count !==0 ">
                                    <highlight v-for="item in leftListingItems.posts" :item="item" :style-mode="1"
                                        :detail-page="'detail'"></highlight>
                                </div>
                            </template>
                        </div>
                    </template>
                    <keep-alive v-if="listingType !== 'articles'">
                        <router-view name="cacheArticles"></router-view>
                    </keep-alive>
                    <keep-alive>
                        <listing-raw v-if="(isListingPage || isArticlesPage) && !layoutDisplay.leftBody === true"
                            :filter-info="filterInfo" :listing-type="listingType"></listing-raw>
                    </keep-alive>
                    <div style="width:100%;height:60px;clear: both;"></div>
                </div>

                <div style="position:fixed;bottom:6px;right:10px;text-align:center;z-index:100;" @click="showMsgBox = true;"
                    v-if="listingType === 'listing'">
                    <div><span class="btn btn-default act-contact-trigger agx-theme-bg"><img style="height:30px;"
                                :src="srcRoot + '/images/sys/msg.png'" /></span> </div>
                </div>

                <div :style="{ display: !showMsgBox ? 'none' : 'block' }" class="modal"
                    style="z-index:12345;background:rgba(1,1,1,0.5);margin-top:50px;">

                    <div class="agx-contact-popup"
                        style="position:relative;background:white;border-radius:8px;overflow:hidden;margin:0 auto;width:100%;max-width:700px;height:90%;top:10px;color:black;">
                        <div class="agx-theme-bg" style="width:100%;height:35px;line-height:35px;">
                            <div class="col-xs-12 agx-theme-bg">
                                <span>{{ shopInfo.shopName }}</span>
                                <span class="btn btn-default" @click="showMsgBox = false" style="float:right;">X</span>
                            </div>
                        </div>

                        <shop-contacts :contacts="shopContacts"></shop-contacts>

                        <!-- <div>
                            <div
                                style="width:90%;max-width:400px;height:80%;max-height:300px;margin:0 auto;overflow-y:auto;border:2px solid #ddd;background:white;padding:10px;">
                                <paged-qa v-if="showMsgBox" :to-user-id="shopInfo.shopUserId" page-path="Enquiry"
                                    page-query="" :get-on-created="false"></paged-qa>
                            </div>
                        </div> -->

                    </div>
                </div>
            </template>
            <template v-slot:bottomNavCenter>
                <span class="btn glyphicon" style="font-weight: bolder;border-left: 1px solid white;border-right: 1px solid white;" @click="onShare">
                    {{lang.common.share}}
                </span>
            </template>
        </layout>
    </div>
</template>


<script>
import laws from './Laws.vue';
import Layout from './layouts/Layout.vue';
import Loading from './base/Loading.vue';
import SharingButtons from './SharingButtons.vue';
import FilterMenu from './FilterMenu.vue';
import FilterMenuForm from './FilterMenuForm.vue';
import PagedInfos from './PagedInfos.vue';
import ListingRaw from './PagedItemsRaw.vue';
import IndexTop from './IndexTop.vue';
import ShopContacts from './ShopContacts.vue';
import ShopFooter from './ShopFooter.vue';
import Slider from './slider/Slider.vue';
import PagedQA from './PagedQA.vue';
import LoginBox from './LoginBox.vue';
import highlight from './cards/highlight.vue';

export default {
    components: {
        Loading: Loading,
        ShopContacts: ShopContacts,
        ShopFooter: ShopFooter,
        ListingRaw: ListingRaw,
        PagedInfos: PagedInfos,
        Slider: Slider,
        PagedQa: PagedQA,
        SharingButtons: SharingButtons,
        LoginBox: LoginBox,
        FilterMenu: FilterMenu,
        FilterMenuForm: FilterMenuForm,
        IndexTop: IndexTop,
        Layout: Layout,
        laws: laws,
        highlight: highlight
    },
    props: {
        "shopInfo": { type: Object, default: null },
        "filterInfo": { type: Object, default: null },
        "sliderData": { type: Array, default: null },
        "enableLsToken": { type: Boolean, default: false }
    },
    computed: {
        configs: function () {
            return this.$store.getters.configs;
        },
        srcRoot: function () {
            return this.$store.getters.configs.srcRoot;
        },
        lang: function () {
            return this.$store.getters.lang;
        },
        viewType: function () {
            return this.configs.shopNature[this.shopInfo.viewCatId];
        },
        shopContacts: function () {
            return this.configs.shopContacts;
        },
        listingType: function () {
            if (this.viewType === "News") {
                return "articles";
            }
            return "listing";
        },
        xAccount: function () {
            return this.$store.getters.account;
        },
        hasLogin: function () {
            return this.$store.getters.account !== null;
        },
        xShowingLogin: function () {
            return this.$store.getters.showingLogin;
        },
        pagedInfos: function () {
            var arr = this.configs.pagedInfos.index;
            return arr;
        },
        isListingPage: function () {
            return this.currentPageName === 'listing'
        },
        isArticlesPage: function () {
            return this.currentPageName === 'articles'
        },
        apiClient: function () {
            return this.mxnAgxApi.apiClient;
        },
        showPlaceHolder() {
            return this.layoutDisplay.leftBody === true && this.isListingPage;
        }
    },
    data: function () {
        return {
            page: 1,
            showMenu: false,
            showIndexTop: this.$router.currentRoute.name === 'index',
            showLaws: true,
            isRegister: false,
            navIn: false,
            showMsgBox: false,
            isLoading: false,
            enableLsToken: false,
            currentUrl: window.location.href,
            currentPageName: this.$router.currentRoute.name,
            layoutDisplay: {},
            uiApiListener: null,
            leftListingItems: null
        }
    },
    methods: {
        onLayoutChange: function (e) {
            console.log('AppStartV2 layout', e);
            this.layoutDisplay = e.display;
        },
        toggleNav: function () {
            this.navIn = !this.navIn;
        },
        toggleMenu: function () {
            this.showMenu = !this.showMenu;
        },
        onLoginCallback: function (e) {
            this.$emit("onlogincallback", e);

            console.log("enableLsToken", this.enableLsToken);
            if (this.enableLsToken === true) {
                var accessToken = e.value.accessToken;
                localStorage.setItem("agx-token", accessToken);
                this.apiClient.netClient.setBeforeRequest(function (arg) {
                    {
                        var token = localStorage.getItem("agx-token");
                        arg.headers["Agx-CJAuth"] = token;
                    }
                });
            }

        },
        showLogin: function (toShow) {
            this.$emit("onshowlogin", toShow);
        },
        onShare: function () {
            this.$emit("onShare");
        },
        onLeftListingLoaded(ret) {
            console.log('left listing items', ret);
            this.leftListingItems = ret;
            if (this.isListingPage) {
                if (ret.posts && ret.posts.length > 0) {
                    //var firstPost = ret.posts[0];
                    //this.$router.push({ name: "detail", query: { postId: firstPost.postId } });
                }
            }
        }
    },
    created: function () {
        this.uiApiListener = {
            onScrollResolve: function (resolve, listingPosition, to, from, savedPosition) {
                console.log("onScrollResolve");
                var isBackButton = (savedPosition !== null && (to.name === 'listing' || to.name === 'articles' || to.name === 'index'));
                var selectorElm = ".scrolling-container";
                if (isBackButton) {
                    document.querySelector(selectorElm).scrollTop = listingPosition.y;
                    resolve({ selector: selectorElm, offset: listingPosition });
                } else {
                    document.querySelector(selectorElm).scrollTop = 0;
                    resolve({ x: 0, y: 0 });
                }
            },
            onKeepPosition: function (listPageName, to, from, next) {
                console.log("onKeepPosition");
                var top = document.querySelector(".scrolling-container").scrollTop;
                if (from.name === listPageName || from.name === 'index') {
                    return top;
                }
            }
        };
        this.mxnAgxScrollApi.on(this.uiApiListener);
    },
    destroyed: function () {
        this.mxnAgxScrollApi.remove(this.uiApiListener);
    },
    watch: {
        '$route'() {
            this.currentPageName = this.$router.currentRoute.name;
            this.showIndexTop = this.currentPageName === 'index';
        },
        'hasLogin'() {
            console.log("this.hasLogin", this.hasLogin);
            if (this.hasLogin === false) {
                localStorage.setItem("agx-token", null);
            }
        }
    }
}
</script>
